"use client";

import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@lattice/frontend/components/ui/tabs";
import StockInsiderTradesChart from "./stock-insider-trades-chart";
import StockPoliticianTradesChart from "./stock-politician-trades-chart";
import StockLobbyingChart from "./stock-lobbying-chart";
import React, { Suspense } from "react";
import { ChartBarIcon, TableIcon } from "lucide-react";
import { Skeleton } from "../ui/skeleton";

export default function TradingTrendsSection({ symbol }: { symbol: string }) {
  const [view, setView] = React.useState<"table" | "chart">("chart");
  const [tab_value, setTabValue] = React.useState("insider-trades");

  return (
    <div>
      <Tabs value={tab_value} onValueChange={setTabValue}>
        <div className="flex justify-start mb-4">
          <TabsList className="bg-grey-7 rounded-lg border border-[#131314] p-2 h-auto gap-1">
            <TabsTrigger
              value="insider-trades"
              className="data-[state=active]:!bg-[#D4D4D4] data-[state=active]:!text-black dark:data-[state=active]:!text-black data-[state=active]:shadow-sm data-[state=active]:border-transparent text-muted-foreground hover:text-foreground hover:bg-white/5 border-transparent px-4 py-2 text-sm font-medium rounded-md transition-all h-auto flex-none"
            >
              Insider Trades
            </TabsTrigger>
            <TabsTrigger
              value="politician-trades"
              className="data-[state=active]:!bg-[#D4D4D4] data-[state=active]:!text-black dark:data-[state=active]:!text-black data-[state=active]:shadow-sm data-[state=active]:border-transparent text-muted-foreground hover:text-foreground hover:bg-white/5 border-transparent px-4 py-2 text-sm font-medium rounded-md transition-all h-auto flex-none"
            >
              Politician Trades
            </TabsTrigger>
            <TabsTrigger
              value="lobbying"
              className="data-[state=active]:!bg-[#D4D4D4] data-[state=active]:!text-black dark:data-[state=active]:!text-black data-[state=active]:shadow-sm data-[state=active]:border-transparent text-muted-foreground hover:text-foreground hover:bg-white/5 border-transparent px-4 py-2 text-sm font-medium rounded-md transition-all h-auto flex-none"
            >
              Lobbying
            </TabsTrigger>
          </TabsList>
        </div>
        <div className="relative">
          <div className="absolute top-4 right-4 z-10 inline-flex rounded-lg border border-[#131314] bg-grey-7 p-2 gap-1">
            <button
              type="button"
              onClick={() => setView("chart")}
              className={`px-3 py-2 rounded-md flex items-center justify-center transition-all ${
                view === "chart"
                  ? "bg-[#D4D4D4] text-black shadow-sm"
                  : "text-muted-foreground hover:text-foreground hover:bg-white/5"
              }`}
            >
              <ChartBarIcon className="w-4 h-4" />
            </button>
            <button
              type="button"
              onClick={() => setView("table")}
              className={`px-3 py-2 rounded-md flex items-center justify-center transition-all ${
                view === "table"
                  ? "bg-[#D4D4D4] text-black shadow-sm"
                  : "text-muted-foreground hover:text-foreground hover:bg-white/5"
              }`}
            >
              <TableIcon className="w-4 h-4" />
            </button>
          </div>
          <Suspense fallback={<Skeleton className="min-h-[600px] w-full" />}>
            <TabsContent value="insider-trades">
              <StockInsiderTradesChart symbol={symbol} view={view} />
            </TabsContent>
            <TabsContent value="politician-trades">
              <StockPoliticianTradesChart symbol={symbol} view={view} />
            </TabsContent>
            <TabsContent value="lobbying">
              <StockLobbyingChart symbol={symbol} view={view} />
            </TabsContent>
          </Suspense>
        </div>
      </Tabs>
    </div>
  );
}
